import { AdminState } from '@/business/administration/models/admin-state'
import { GetAccountsPayload } from '@/business/administration/store/models/get-accounts-payload'
import { Api } from '@/api/api'
import { AdminAccount } from '@/api/generated'
import { Injector } from '@/config/dependency-injection'
import { NotificationService } from '@/shared/services/notification-service'
import { Loading } from '@/shared/decorators/loading'
import { MarkAsSpamPayload } from '@/business/administration/store/models/mark-as-spam-payload'

export class AdminService {
  public state: AdminState = {
    accounts: [],
  }

  private notificationService = Injector.get(NotificationService)
  private lastPayload?: GetAccountsPayload

  @Loading('admin_get-accounts')
  public getAccounts(payload?: GetAccountsPayload): Promise<AdminAccount[]> {
    this.lastPayload = payload

    return Api.Admin.getAccounts({
      includeDeleted: payload?.includeDeleted ?? false,
      organisationId: payload?.organisationId ?? undefined,
    }).then(response => {
      this.state.accounts = response

      return response
    })
  }

  @Loading('admin_mark-as-spam', 'accountId')
  public markAccountAsSpam({ accountId, spam }: MarkAsSpamPayload): Promise<void> {
    return Api.Admin.markAccountAsSpam({
      accountId,
      markAsSpamRequest: {
        spam,
      },
    }).then(() => {
      this.reloadAccounts()
    })
  }

  public reloadAccounts(): void {
    this.getAccounts(this.lastPayload).catch(this.notificationService.errorHandler)
  }
}
